module.exports = __webpack_public_path__ + "media/mask-db5d12c2.svg";